import { defineMessages } from 'react-intl';

/** The preview still of a style card (owner 2026-10-19). */
export const stylePreviewMessages = defineMessages({
  making: {
    id: 'app.sml.musicVideo.directed.style.preview.making',
    defaultMessage: 'Making a preview',
  },
  alt: {
    id: 'app.sml.musicVideo.directed.style.preview.alt',
    defaultMessage: 'A preview of the style {style}',
  },
  open: {
    id: 'app.sml.musicVideo.directed.style.preview.open',
    defaultMessage: 'See the preview of {style} larger',
  },
});
